module.exports = __webpack_public_path__ + "static/media/starn22_logo.a88a67b2.png";